//#region IMPORT
import React, { useEffect } from 'react';
import {
  Card as MuiCard,
  Button as MuiButton,
  Box as MuiBox,
  Box,
  Paper,
  Typography,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Divider,
  Slide,
  IconButton,
  Tooltip,
  tooltipClasses,
  styled,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { AgGridReact } from 'ag-grid-react';
import Commons from '../../Services/Common/Common';
import Icon from '../../Assets/Icon/CustomIcons';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { resetAddButtonError } from '../../Reducer/StatusFlagsReducer';
// 필터관련 컴포넌트
import { GridFilterButton } from '../../Components/GridFilterButton';
import { GridFilterSummary } from '../../Components/GridFilterSummary';
//#endregion

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// 커스터마이징된 Tooltip 생성
const LargeTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#4CAF50', // 본체 배경 초록
    color: '#fff',
    fontSize: '0.9rem',
    padding: theme.spacing(1),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#4CAF50', // 꼬리도 동일 색으로!
  },
}));

function BusinessGridCommon({
  getRowId,
  gridRef,
  columnDefs,
  gridState1,
  rowData,
  setSelectedRowData,
  setChangedRowData,
  gridContext,
  editable = false,
  onSelectionChanged,
  onCellValueChanged,
  onCellClicked,
  onCellKeyDown,
  gridSx,
  flex = 0,
  group = false,
  autoGroupColumnDef = {},
  rowSelection = 'multiple',
  title1 = '기본정보',
  pagination = true,
  onRowDragEnd,
  rowDragManaged = false,
  onCellEditingStarted,
  onCellEditingStopped,
  pinnedBottomRowData,
  getRowStyle,
  getRowHeight,
  /** 셀 밖 클릭 시 편집 종료. 팝업 에디터(예: PassOrDateCellEditor) 사용 시 false 권장 */
  stopEditingWhenCellsLoseFocus = true,
  /** 헤더 높이 자동 조절 (긴 헤더 텍스트 개행 시 사용) */
  autoHeaderHeight = false,
  /** 셀 클릭 시 포커스·스크롤 이동 억제 (선택 전용 그리드 등) */
  suppressCellFocus = false,
  suppressRowClickSelection = false,
  animateRows = true,

  /* Button Props */
  // left side
  buttonsSx1, // object
  searchClick1 = () => {},
  addClick1 = () => {},
  saveClick1 = () => {},
  deleteClick1 = () => {},
  printClick1 = () => {},
  fileUploadClick1 = () => {},
  fileDownloadClick1 = () => {},
  refreshClick1 = () => {},
  applyClick1 = () => {},
  applyCancleClick1 = () => {},
  copyClick1 = () => {},

  /* Stack Props */
  // left side
  searchYn1 = 'N', // string
  copyYn1 = 'N', // string
  addYn1 = 'Y', // string
  saveYn1 = 'N', // string
  deleteYn1 = 'Y', // string
  printYn1 = 'N', // string
  multiPrintYn1 = 'N', // string
  other1, // object
  printItem1 = [],
  fileUploadYn1 = 'N', // string
  fileDownloadYn1 = 'N', // string
  refreshYn1 = 'Y', // string
  applyYn1 = 'N', // string
  applyName1 = '', //string
  applyCancleName1 = '', //string
  /** 작업환경측정 등에서만 사용하는 옵션: 드래그 채우기/범위 선택 */
  enableRangeSelection = false,
  enableFillHandle = false,
  /** ag-Grid rowClassRules 추가 (기본 new-row/edit-row/delete-row와 병합) */
  extraRowClassRules,
}) {
  const dispatch = useDispatch();
  const isAddButtonError = useSelector(
    (state) => state.StatusFlags.isAddButtonError
  );

  // 필터관련
  const [gridApi, setGridApi] = React.useState(null);
  const [gridColumnApi, setGridColumnApi] = React.useState(null);
  const [selectedFilters, setSelectedFilters] = React.useState({});
  const [headerMap, setHeaderMap] = React.useState({});
  const [isFiltered, setIsFiltered] = React.useState(false);
  const selectedFiltersRef = React.useRef(selectedFilters);

  // useEffect(() => {
  //   selectedFiltersRef.current = selectedFilters;
  //   if (gridRef?.current?.api) {
  //     gridRef.current.api.onFilterChanged(); // 필터 적용
  //   }
  // }, [selectedFilters]);

  const [open1, setOpen1] = React.useState(false);
  const anchorRef1 = React.useRef(null);
  const [dialogToggle1, setDialogToggle1] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });
  useEffect(() => {
    if (isAddButtonError) {
      const timer = setTimeout(() => {
        dispatch(resetAddButtonError());
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [isAddButtonError]);

  const HandleToggle1 = () => {
    setOpen1((prevOpen) => !prevOpen);
  };
  const HandleClose1 = (event) => {
    if (anchorRef1.current && anchorRef1.current.contains(event.target)) {
      return;
    }

    setOpen1(false);
  };
  function HandleListKeyDown1(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen1(false);
    } else if (event.key === 'Escape') {
      setOpen1(false);
    }
  }

  const gridOptions = {
    singleClickEdit: true,
    rowClassRules: {
      ...(extraRowClassRules && typeof extraRowClassRules === 'object'
        ? extraRowClassRules
        : {}),
      'new-row': (params) =>
        params.data &&
        params.data.newYn === 'Y' &&
        params.data.workerOpinionRowYn !== 'Y', // 근로자 의견 반영 행은 별도 강조색 사용
      'delete-row': (params) => params.data && params.data.deleteYn === 'Y',
      'edit-row': (params) =>
        params.data && params.data.editYn === 'Y' && params.data.newYn !== 'Y',
    },
    isExternalFilterPresent: () => true, // 외부 필터 사용
    doesExternalFilterPass(node) {
      if (node.data?.newYn === 'Y') return true;
      if (node.data?.deleteYn === 'Y') return true;

      // 선택된 필터 값으로 통과 여부 판단
      const filters = selectedFiltersRef.current || {};
      return Object.keys(filters).every((field) => {
        const values = filters[field] || [];
        if (values.length === 0) return true;
        return values.includes(node.data[field]);
      });
    },
    // 드래그 채우기/범위 선택 옵션 (페이지별로 켜기 위해 props로 제어)
    enableRangeSelection,
    enableFillHandle,
    fillHandleDirection: enableFillHandle ? 'xy' : 'x',
  };

  const LeftSideButtons = () => {
    /** 원형 테두리 아이콘 버튼 — flex stretch로 줄 높이 따라 늘어나지 않도록 고정 */
    const roundIconButtonSx = {
      border: 1,
      width: 40,
      height: 40,
      borderRadius: '50%',
      boxSizing: 'border-box',
    };

    return (
      <MuiCard
        sx={{
          flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          overflow: 'visible',

          ...buttonsSx1,
        }}
      >
        {/* 제목 + 필터 한 그룹 */}
        <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            sx={{
              fontSize: '1.05rem',
              fontWeight: 'bold',
              color: '#2CA900',
              mr: 1, // 오른쪽으로 16px 여백
            }}
          >
            {title1}
          </Typography>

          {gridRef && (
            <GridFilterButton
              gridRef={gridRef}
              gridApi={gridApi}
              gridColumnApi={gridColumnApi}
              rowData={rowData}
              selectedFiltersRef={selectedFiltersRef}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              setIsFiltered={setIsFiltered}
              setHeaderMap={setHeaderMap}
              headerMap={headerMap}
            />
          )}
        </MuiBox>

        <MuiBox
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            my: 1.3,
            alignItems: 'center',
          }}
        >
          {/* other 버튼 스타일 sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }} */}
          {other1 && other1}

          {applyYn1 === 'Y' && !Commons.IsMobile() && (
            <>
              <MuiButton
                sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={applyClick1}
              >
                {applyName1}
              </MuiButton>
              <MuiButton
                sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={applyCancleClick1}
              >
                {applyCancleName1}
              </MuiButton>
            </>
          )}
          {searchYn1 === 'Y' && (
            <MuiButton
              sx={{ color: '#2196F3', borderColor: '#2196F3' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={searchClick1}
            >
              <SearchIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              검색
            </MuiButton>
          )}
          {addYn1 === 'Y' && (
            <motion.div
              style={{ display: 'inline-flex', alignItems: 'center' }}
              animate={isAddButtonError ? { y: [0, -20, 0, -10, 0] } : { y: 0 }}
              transition={
                isAddButtonError
                  ? {
                      duration: 0.6,
                      repeat: Infinity,
                      repeatDelay: 1,
                      ease: 'easeOut',
                    }
                  : { duration: 0 }
              }
            >
              <LargeTooltip title="추가" arrow placement="top">
                <IconButton
                  color="primary"
                  sx={roundIconButtonSx}
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    dispatch(resetAddButtonError());
                    addClick1();
                  }}
                >
                  <AddIcon fontSize="small" />
                </IconButton>
              </LargeTooltip>
            </motion.div>
          )}
          {saveYn1 === 'Y' && !Commons.IsMobile() && (
            <MuiButton
              sx={{ color: '#2CA900', borderColor: '#2CA900' }}
              variant="outlined"
              onClick={saveClick1}
            >
              <SaveIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              저장
            </MuiButton>
          )}
          {refreshYn1 === 'Y' && (
            <LargeTooltip title="재조회" arrow placement="top">
              <IconButton
                color="secondary"
                sx={roundIconButtonSx}
                size="small"
                variant="outlined"
                onClick={refreshClick1}
              >
                <RefreshIcon fontSize="small" />
              </IconButton>
            </LargeTooltip>
          )}
          {deleteYn1 === 'Y' && (
            <LargeTooltip title="삭제" arrow placement="top">
              <IconButton
                color="error"
                sx={roundIconButtonSx}
                size="small"
                variant="outlined"
                onClick={deleteClick1}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </LargeTooltip>
          )}
          {printYn1 === 'Y' && multiPrintYn1 === 'Y' && !Commons.IsMobile() ? (
            <div>
              <MuiButton
                ref={anchorRef1}
                id="composition-button"
                aria-controls={open1 ? 'composition-menu' : undefined}
                aria-expanded={open1 ? 'true' : undefined}
                aria-haspopup="true"
                sx={{ m: 1, color: '#9370DB', borderColor: '#9370DB' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={HandleToggle1}
              >
                <PrintIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
                인쇄
              </MuiButton>
              <Popper
                open={open1}
                anchorEl={anchorRef1.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                sx={{ zIndex: 1300 }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom-start'
                          ? 'left top'
                          : 'left bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={HandleClose1}>
                        <MenuList
                          autoFocusItem={open1}
                          id="composition-menu"
                          aria-labelledby="composition-button"
                          onKeyDown={HandleListKeyDown1}
                        >
                          {printItem1.map((_item, _index) => {
                            return (
                              <>
                                <MenuItem
                                  key={_index}
                                  onClick={(e) => {
                                    _item.onClick();
                                    HandleClose1(e);
                                  }}
                                  sx={{ fontSize: '14px' }}
                                >
                                  {_item.name}
                                </MenuItem>
                                {_index < printItem1.length - 1 && <Divider />}
                              </>
                            );
                          })}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          ) : printYn1 === 'Y' && !Commons.IsMobile() ? (
            <MuiButton
              sx={{ color: '#9370DB', borderColor: '#9370DB' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={printClick1}
            >
              <PrintIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              인쇄
            </MuiButton>
          ) : (
            <></>
          )}
          {fileUploadYn1 === 'Y' && (
            <LargeTooltip title="엑셀업로드" arrow placement="top">
              <IconButton
                color="secondary"
                ref={anchorRef1}
                id="composition-button"
                aria-controls={open1 ? 'composition-menu' : undefined}
                aria-expanded={open1 ? 'true' : undefined}
                aria-haspopup="true"
                sx={roundIconButtonSx}
                size="small"
                variant="outlined"
                onClick={fileUploadClick1}
              >
                <Icon.FolderUpload fontSize="small" />
              </IconButton>
            </LargeTooltip>
          )}
          {fileDownloadYn1 === 'Y' && (
            <LargeTooltip title="엑셀다운로드" arrow placement="top">
              <IconButton
                color="success"
                sx={roundIconButtonSx}
                size="small"
                variant="outlined"
                onClick={fileDownloadClick1}
              >
                <Icon.FolderDownload fontSize="small" />
              </IconButton>
            </LargeTooltip>
          )}
          {copyYn1 === 'Y' && (
            <LargeTooltip title="복사" arrow placement="top">
              <IconButton
                sx={{
                  ...roundIconButtonSx,
                  color: '#2196F3',
                  borderColor: '#2196F3',
                }}
                size="small"
                variant="outlined"
                onClick={copyClick1}
              >
                <Icon.Copy fontSize="small" />
              </IconButton>
            </LargeTooltip>
          )}
          {!other1 &&
            copyYn1 === 'N' &&
            applyYn1 === 'N' &&
            searchYn1 === 'N' &&
            addYn1 === 'N' &&
            saveYn1 === 'N' &&
            deleteYn1 === 'N' &&
            printYn1 === 'N' &&
            fileUploadYn1 === 'N' &&
            fileDownloadYn1 === 'N' &&
            refreshYn1 === 'N' && (
              <MuiButton
                sx={{
                  opacity: 0, // 투명
                  pointerEvents: 'none', // 클릭 방지
                  borderColor: 'transparent',
                }}
                variant="outlined"
              >
                빈 버튼
              </MuiButton>
            )}
        </MuiBox>
      </MuiCard>
    );
  };
  return (
    <Box sx={{ height: '100%', pt: 1 }}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderColor: 'divider',
          borderRadius: '10px',
          p: 2,
          pt: 1,
          ...gridSx,
          backgroundColor: '#FFF',
        }}
      >
        {LeftSideButtons()}
        {/* 필터 요약 바 */}
        {gridRef && (
          <GridFilterSummary
            isFiltered={isFiltered}
            selectedFilters={selectedFilters}
            headerMap={headerMap}
            setSelectedFilters={setSelectedFilters}
          />
        )}
        <AgGridReact
          getRowId={getRowId}
          getRowStyle={getRowStyle}
          getRowHeight={getRowHeight}
          ref={gridRef}
          context={gridContext}
          autoHeaderHeight={autoHeaderHeight}
          onGridReady={(params) => {
            setGridApi(params.api);
            setGridColumnApi(params.columnApi);
          }}
          rowDragManaged={rowDragManaged}
          animateRows={animateRows}
          suppressCellFocus={suppressCellFocus}
          suppressRowClickSelection={suppressRowClickSelection}
          columnDefs={columnDefs}
          rowData={rowData}
          pinnedBottomRowData={pinnedBottomRowData}
          enableRangeSelection={enableRangeSelection}
          fillHandleDirection={enableFillHandle ? 'xy' : undefined}
          suppressFillHandle={!enableFillHandle}
          defaultColDef={{
            cellDataType: false,
            flex: flex,
            minWidth: 100,
            editable: editable,
            resizable: true,
            sortable: true,
            filter: true,
            // floatingFilter: true,
          }}
          onCellEditingStarted={onCellEditingStarted}
          onCellEditingStopped={onCellEditingStopped}
          onCellClicked={onCellClicked}
          onCellKeyDown={onCellKeyDown}
          gridOptions={gridOptions}
          autoGroupColumnDef={autoGroupColumnDef}
          groupDefaultExpanded={1} // 그룹 펼치기
          stopEditingWhenCellsLoseFocus={stopEditingWhenCellsLoseFocus}
          rowSelection={rowSelection}
          onSelectionChanged={() => {
            if (onSelectionChanged) {
              onSelectionChanged(gridRef);
            } else if (gridRef?.current?.api) {
              GridFunctions.onSelectionChanged(gridRef, (_selected) => {
                setSelectedRowData(_selected);
              });
            } else {
              console.log('gridRef1 or API not ready');
            }
          }}
          onCellValueChanged={(e) => {
            if (onCellValueChanged) {
              onCellValueChanged(e, gridRef);
            } else {
              GridFunctions.onCellValueChanged(
                e,
                gridRef,
                setChangedRowData,
                gridState1,
                dispatch
              );
            }
          }}
          pagination={pagination} // enable pagination
          paginationPageSize={100} // sets 10 rows per page (default is 100)
          paginationPageSizeSelector={[100, 200, 500, 1000]} // allows the user to select the page size from a predefined list of page sizes
          localeText={{
            // 기본 텍스트
            page: '페이지',
            more: '더보기',
            to: '~',
            of: '/',
            next: '다음',
            last: '마지막',
            first: '처음',
            previous: '이전',
            loadingOoo: '불러오는 중...',

            // 필터 & 패널 등
            selectAll: '전체 선택',
            searchOoo: '검색...',
            blanks: '공백',

            // 페이지 사이즈 선택기
            pageSizeSelectorLabel: '페이지 당 행 수',

            // 기본 페이지네이션 설명
            paginationPageSize: '페이지 당 행 수',
            paginationNumberFormatter: (params) => `${params.value}`,
          }}
          onRowDragEnd={onRowDragEnd}
          tooltipShowDelay={300}
          tooltipHideDelay={1500}
        />
      </Box>
    </Box>
  );
}

export default BusinessGridCommon;
